import React from 'react';
import { areEqual } from 'react-window';
import { TaskCard } from './task-card';
import { parseDraggableId } from './utils';

interface ItemProps {
  itemId: string;
}

export const Item = React.memo(({ itemId }: ItemProps) => {
  const [, , taskId] = parseDraggableId(itemId);

  return taskId ? <TaskCard taskId={taskId} /> : null;
}, areEqual);
